<template>
  <div>
    <b-row>
      <b-col>
        <b-row class="mb-3 my-2">
          <b-col>
            <div
              :class="showProjects ? null : 'collapsed'"
              :aria-expanded="showProjects ? 'true' : 'false'"
              aria-controls="collapse-1"
              @click="showProjects = !showProjects"
            >
              <span class="text-muted fs-20 p-0">Proyectos</span>
              <font-awesome-icon v-if="showProjects" :icon="['far', 'chevron-down']" size="lg" fixed-width />
              <font-awesome-icon v-else :icon="['far', 'chevron-right']" size="sm" fixed-width />
            </div>
          </b-col>
          <b-col class="text-right">
            <Button v-if="projects.length > 0 && showProjects" variant="blue" @click="openNewFormModal" :disabled="!ready">
              <font-awesome-icon :icon="['fas', 'plus-circle']" fixed-width />
              <span class="pl-1">Nuevo Proyecto</span>
            </Button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-collapse id="collapse-1" v-model="showProjects">
              <div v-if="ready">
                <div v-if="projects.length > 0">
                  <b-form-group>
                    <b-input-group>
                      <b-input
                        v-model="searchTerm"
                        placeholder="Buscar proyecto por código o nombre"
                        @keyup.enter="search"
                      />
                      <b-input-group-append>
                        <b-button variant="outline-secondary" @click="search">
                          <font-awesome-icon :icon="['fas', 'search']" fixed-width />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-card v-for="project in filteredProjects" :key="project.id" class="project-card">
                    <b-card-header class="card-header">
                      <b-row align-v="center" class="mb-1 pl-2 border-bottom">
                        <b-col cols="10">
                          <div class="project-card-title">
                            <font-awesome-icon :icon="['far', 'briefcase']" size="sm" fixed-width />
                            <span class="px-2">{{ project | projectId }}:</span>
                            <span>{{ project.name }}</span>
                          </div>
                        </b-col>
                        <b-col v-if="project.user_id === currentUser.id || isAdmin" cols="2" align-self="start" class="text-right pr-1">
                          <Button @click="formMode = 'edit'; openEditFormModal(project);">
                            <font-awesome-icon :icon="['far', 'edit']" size="sm" fixed-width />
                          </Button>
                        </b-col>
                      </b-row>
                      <b-row class="lower-row">
                        <b-col sm="4" cols="6">
                          <div v-if="project.project_type === 'Comercial'">
                            <font-awesome-icon :icon="['fas', 'industry-alt']" fixed-width />
                            <span class="pl-2">Comercial</span>
                          </div>
                          <div v-else-if="project.project_type == 'Residencial'">
                            <font-awesome-icon :icon="['fas', 'home']" fixed-width />
                            <span class="pl-2">Residencial</span>
                          </div>
                          <div v-else>
                            <font-awesome-icon :icon="['fas', 'parking']" fixed-width />
                            <span class="pl-2">Parking</span>
                          </div>
                        </b-col>
                        <b-col sm="4" cols="6">
                          <font-awesome-icon :icon="['fas', 'calendar-alt']" fixed-width />
                          <span class="pl-2">{{ project.created_at | formatDate }}</span>
                        </b-col>
                        <b-col sm="4" cols="6">
                          <font-awesome-icon :icon="['fas', 'user-circle']" fixed-width />
                          <span class="pl-2">{{ project.user.first_name + ' ' + project.user.last_name }}</span>
                        </b-col>
                        <b-col sm="4" cols="6">
                          <font-awesome-icon :icon="['fas', 'user-tie']" fixed-width />
                          <span class="pl-2">{{ project.manager }}</span>
                        </b-col>
                        <b-col sm="8" cols="12">
                          <font-awesome-icon :icon="['fas', 'map-marker-alt']" fixed-width />
                          <span class="pl-2">{{ project.address }}</span>
                        </b-col>
                      </b-row>
                      <b-row align-h="center" class="mt-2">
                        <Button :to="`/app/prod/proyectos/${project.id}`" size="sm">
                          <span>Ver Detalles</span>
                        </Button>
                      </b-row>
                    </b-card-header>
                  </b-card>
                  <b-card v-if="filteredProjects.length === 0" class="project-card">
                    <b-card-header class="card-header">
                      <div class="text-center mt-3 mb-1" style="color: #6c757d">
                        <span class="fs-18">No resultados para la búsqueda: <b style="color: #1d58b7">{{ searchTerm }}</b></span>
                      </div>
                    </b-card-header>
                  </b-card>
                </div>
                <div v-else class="dash-card d-flex justify-content-center align-items-center p-0">
                  <Button variant="blue" @click="openNewFormModal" :disabled="!ready">
                    <font-awesome-icon :icon="['fas', 'plus-circle']" fixed-width />
                    <span class="pl-1">Nuevo Proyecto</span>
                  </Button>
                </div>
              </div>
            </b-collapse>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- New/Edit Project Modal -->
    <b-modal lazy v-model="formModalShow" centered>
      <template #modal-title>
        <font-awesome-icon :icon="['far', 'briefcase']" fixed-width />
        <span v-if="formMode === 'new'">Crear nuevo proyecto</span>
        <span v-else-if="formMode === 'edit'">{{ selectedProject.name }}</span>
      </template>
      <b-container>
        <b-row align-h="center">
          <b-col>
            <b-form-group>
              <template #label>
                <span>Nombre Proyecto</span><span class="asterisk">*</span>
              </template>
              <b-input v-model="form.name" size="sm" />
            </b-form-group>

            <b-form-group>
              <template #label>
                <span>Dirección</span><span class="asterisk">*</span>
              </template>
              <b-textarea v-model="form.address" size="sm"></b-textarea>
            </b-form-group>

            <b-form-group label="Encargado">
              <b-input v-model="form.manager" size="sm" />
            </b-form-group>

            <b-form-group>
              <template #label>
                <span>Tipo de ciclos de proyecto</span><span class="asterisk">*</span>
              </template>
              <b-radio-group v-model="form.project_type" size="sm" stacked>
                <b-radio value="Comercial">Comercial o Industrial</b-radio>
                <b-radio value="Residencial">Residencial o Condominio</b-radio>
                <b-radio value="Parqueo">Parqueo</b-radio>
              </b-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <Button v-if="formMode === 'new'" variant="green" class="float-right" :disabled="!formValid" @click="createProject">Crear</Button>
        <Button v-else variant="green" class="float-right" :disabled="!formValid" @click="updateProject">Guardar</Button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Button from '../../shared/Button'

export default {
  name: 'ShowProjects',
  components: { Button },
  props: {
    projects: {
      type: Array,
      required: true
    },
    ready: {
      type: Boolean,
      required: true,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      id: Number(this.$route.params.id),
      processing: false,
      showProjects: true,
      formModalShow: false,
      formMode: 'new',
      form: {
        name: null,
        address: null,
        manager: null,
        project_type: null,
        user_id: null
      },
      selectedProject: null,
      searchTerm: ''
    }
  },
  computed: {
    ...mapGetters(['isAdmin']),
    currentUser () { return this.$store.state.currentUser },
    formValid () {
      return this.form.name && this.form.address && this.form.project_type ? true : false
    },
    filteredProjects () {
      if (!this.searchTerm) return this.projects

      const term = this.searchTerm.toLowerCase()

      return this.projects.filter(project => {
        const code = `p-${project.id.toString().padStart(6, '0')}`
        return project.name?.toLowerCase()?.includes(term) ||code.includes(term)
      })
    }
  },
  methods: {
    openNewFormModal () {
      this.formMode = 'new'
      this.form.name = null
      this.form.address = null
      this.form.project_type = null
      this.form.manager = null
      this.form.user_id = this.currentUser.id
      this.formModalShow = true
    },
    openEditFormModal (currentProject) {
      this.formMode = 'edit'

      const { name, address, project_type, manager, user_id } = currentProject
      this.selectedProject = currentProject

      this.form.name = name
      this.form.address = address
      this.form.project_type = project_type
      this.form.manager = manager
      this.form.user_id = user_id
      this.formModalShow = true
    },
    createProject () {
      if (this.processing) { return }
      this.processing = true
      let data = this.form
      data['client_id'] = this.id
      this.$http.post('/api/production/projects', { project: data })
        .then(response => {
          // console.log(response)
          let newProject = response.data
          newProject['detailShow'] = false
          newProject['loading'] = false

          this.$emit('addProjectToState', newProject)
        })
        .catch(error => {
          // console.log(error)
          this.$emit('displayAlert', { message: 'No funcionó', variant: 'danger' })
        })
        .finally(() => {
          this.processing = false
          this.alertShow = true
          this.formModalShow = false
        })
    },
    updateProject () {
      if (this.processing) { return }
      this.processing = true
      this.$http.put(`/api/production/projects/${this.selectedProject.id}`, {
          project: this.form
        })
        .then(response => {
          // console.log(response)

          this.$emit('updateProjectInState', response.data)
        })
        .catch(error => {
          // console.log(error)
          this.$emit('displayAlert', { message: 'No se pudo guardar los cambios', variant: 'danger' })
        })
        .finally(() => {
          this.processing = false
          this.alertShow = true
          this.formModalShow = false
        })
    },
    search () {}
  }
}
</script>

<style lang="scss" scoped>
.lower-row {
  padding: 0 3em 0 3em;
  font-size: 12px;
  color: #aaa;
}
.project-card {
  font-size: 15px;
  line-height: 2;
  margin-bottom: 1.5em;
}
.project-card-title {
  font-size: 16px;
  color: #163D7D;
}
.card-header {
  padding-top: 2px !important;
  background-color: #F5F6FC;
}
.card-body {
  padding: 0 !important;
}
</style>
